import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateMaterialTransparent } from '../../redux/material_transparent/material_actions';

const mapStateToProps = state => ({
  isDuplicating: state.material.transparent.isDuplicating,
  errorMessage: state.material.transparent.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateMaterialTransparent(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/TransparentMaterialDuplicateModal.js